import React from "react";
import { CurrentVendorContextType, VendorControllerContextType } from "./types";

export const VendorControllerContext = React.createContext<
  VendorControllerContextType | undefined
>(undefined);

export const CurrentVendorContext = React.createContext<
  CurrentVendorContextType | undefined
>(undefined);
